<template>
    <div class="MediaSourceEditor">
		<div  class="">
			<div>
				<div class="filter-tag-row"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
					<!-- <span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Источников найдено: {{ this.masApi_total }}</span> -->
				</div> 
			</div>
			<div class="row">
				<div class="col-lg-8 mt-2"  v-show="bShowFilter">
					<ReFilter
					:masAllFilterParams="masAllFilterParams"
					v-model="objGetParams"
					v-on:filterapply="OnFilterApply"
					name="MediaSourceEditor"/>
				</div>
			</div>
		</div>
		<card >
			<div class="">
				<h5><i class="tim-icons icon-send text-success mr-3"></i>Добавить новый источник</h5>
				
			</div>
			
			<div class="d-flex">
				<!-- <ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Добавить источник" /> -->
				<base-input
						v-model="mediaSource.val"
						autocomplete="off"
						type="text"
						placeholder="Название"
						class="mr-2"
					>
					</base-input>
				<base-input
						v-model="mediaSource.sortIndex"
						autocomplete="off"
						type="number"
						placeholder="Порядок"
						class="mr-2"
					>
					</base-input>

					<base-button @click="addMediaSource()" type="success" simple class="mr-2 my-0">Добавить</base-button>

			</div> 
		</card>
		<card
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	>
			<el-table :data="ApiData" style="width: 100%;">

			<el-table-column
				type="index"
				property="id"
				width="80"
			>
			</el-table-column>
			<!-- <el-table-column
				label="id"
				property="id"
				width="250"
			>
			</el-table-column> -->
			<!-- скрываю колонку ИД, Юле она не нужна, будет путать-->

			<el-table-column
				label="Порядок"
				property="sortIndex"
				width="160"
				sortable
			>
				<template v-slot="scope">		
					<base-input
						v-model="scope.row.sortIndex"
						autocomplete="off"
						type="number"
					>
					</base-input>
				</template>
			</el-table-column>

			<el-table-column
				label="Название"
				property="val"
				min-width="200"
				sortable
			>
				<template v-slot="scope">
					<base-input
						v-model="scope.row.val"
						autocomplete="off"
						type="text"
					>
					</base-input>
				</template>
			</el-table-column>

			<!-- <el-table-column 
				width="120"
				label="act"
				property="act"
				sortable
			>
				<template slot-scope="scope">		
					<base-input
						v-model="scope.row.act"
						autocomplete="off"
						type="number"
					>
					</base-input>
				</template>
			</el-table-column> -->

			<el-table-column
					width="130"
					label="Сохранить"
				>
					<template v-slot="scope">			
						<el-button class="no-border my-0" >
							<button class="ml-3 btn btn-icon btn-simple btn-success"  @click="UpdateTable(scope.row)">
								<i class="tim-icons icon-book-bookmark"></i>
							</button>											
						</el-button>
					</template>
			</el-table-column>
			<el-table-column
				width="100"
				label=""
			>
				<template v-slot="scope">		
					<ReActionBtns :masActions="masActions[scope.$index]"/>
				</template>
			</el-table-column>			 
			</el-table>
			<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)*parseInt(count2page)" 
				:perPage="parseInt(count2page)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>
		</card>
    
		</div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { BaseSwitch } from 'src/components/index';
// import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
import Pagination from 'src/our_components/RePagination';
import ReActionBtns from 'src/our_components/ReActionBtns.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';


export default {
	name: 'media_source_editor-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// BaseSwitch,
        // ReFormPrinter,
        Pagination,
		ReActionBtns,
		ReFilterBtn,
        ReFilter

	},
	data() {
		return {
			ApiData: [],
			// masAllFormParams: this.currentFormConfig(),
			// currentApiFormMethod: this.currentApiFormMethodComp(),
			objGetParams:{},
			masObjects_total: 0,
			count2page: 10,
			masActions:[],	
			fullscreenLoading: false,
			bShowFilter: false,
			mediaSource: {val:'', sortIndex:'', descr:'',},
			masAllFilterParams: this.currentFilterConfig(),

		};
	},
	methods: {
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}

			// this.$GVO.ApiCall('leads2bpservice.GetCatForSelOptions',{flt:{'alldata': true, 'c2p':100}} ) 
			this.$GVO.ApiCall('GetCatForSelOptions',{obj:'../plugins/leads2bpservice',flt:{'alldata': true, ...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					this.masObjects_total = 0;
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
						// console.log('objApi.data ', objApi.countpage); 
						// this.masObjects_total = objApi.countpage;

						this.masActions = [];
						for (let i = 0; i < this.ApiData.length; i++) {
							this.masActions.push([
								{
									actionType: 'switcher',
									label_on: 'Вкл',
									label_off: 'Выкл',
									action_model: this.ApiData[i].act=='1'?true:false,						
									onClickApi: {apiMethod: 'CHANGE_ACT',apiParam:{obj:'../plugins/leads2bpservice',flt:{id:this.ApiData[i].id}}},
								},

							]);							
						}


					}else{
						this.ApiData = [];
						this.masObjects_total=0;
					}
				}else{
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('GET_FILTER_MediaSource',{obj:'../plugins/leads2bpservice'})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			// return require('src/conf/supportFilterConfig.js').support_FilterConfig;
			return [];
		},
		OnFilterApply(data){
			// console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},	

		// currentFormConfig() {
		// 	this.$GVO.ApiCall('menu_adm.GET_FORM_MODEL',{})
		// 		.then((objApi) => {
		// 			if(objApi.success){
		// 				this.masAllFormParams = objApi.config;
		// 			}
		// 		})
		// 		.catch(errorObjApi => console.log(errorObjApi));
		// 	return [];
		// },
		// currentApiFormMethodComp(){
        //     return {apiMethod:'menu_adm.INS',apiParam:{iData:[]}};
        // },
		// SuccessGo(evt,dopParam){
	    //     this.masAllFormParams = this.currentFormConfig();
		// 	this.getApiData();
		// },		

		// 	return saveToServName;
		// },
		// DeleteRow(row){
		// 	if(row.id != null){
		// 		this.$GVO.ApiCall('BP_CHECKLIST.DEL',{ flt:{id: row.id}}) 
		// 			.then((objApi) => {
		// 				if(objApi.success === true){
		// 					this.getApiData();
		// 				}else{
		// 					alert('Не удалилось');
		// 				}
		// 			}).catch(errorObjApi => {console.log(errorObjApi);});
		// 	}
		// },
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			// this.OnFilterApply();
		},

		UpdateTable(row){
			// console.log('UpdateMenu. This is row id '+ row.id + ' and menu row name is ' + row.name); 
			let sourceId='';
			if(row.id != null){
				sourceId = row.id.replace(/[{}]/g, "");

				// console.log('sourceId',sourceId);
				this.$GVO.ApiCall('UPDMediaSource',{obj:'../plugins/leads2bpservice',flt:{'id': row.id},uData:{
				// this.$GVO.ApiCall('UPDMediaSource.UPD',{ flt:{id: row.id},uData:{
					'id': row.id, 
					'sortIndex': row.sortIndex,
					'val': row.val, 
					'descr': row.descr,
					'act': row.act,
					}}).then((objApi) => {
						//console.log(objApi);
						if(objApi.success === true){
							this.getApiData();
							this.openFullScreen1();
						}else{
							alert('Не сохранилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}

		}, 
		addMediaSource(){
			this.$GVO.ApiCall('INSMediaSource',{obj:'../plugins/leads2bpservice',flt:{},iData:{
				// this.$GVO.ApiCall('UPDMediaSource.UPD',{ flt:{id: row.id},uData:{
				// 'id': '', 
				'sortIndex': this.mediaSource.sortIndex,
				'val': this.mediaSource.val, 
				'descr': this.mediaSource.descr,
				// 'act': row.act,
				}}).then((objApi) => {
					// console.log(objApi);
					if(objApi.success === true){
						this.getApiData();
						// this.openFullScreen1();
					}else{
						alert('Не сохранилось');
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});
		},
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 10000);
		},
	},		
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style>
.MediaSourceEditor .bntGroup {
	display: flex;
	justify-content: flex-end;
}
.MediaSourceEditor .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: center;
	flex-wrap: wrap;
}
.MediaSourceEditor .form-options-group > div{
	margin-right: 5px;
}
.MediaSourceEditor .form-group {
	margin-bottom: 0px!important;
}
.MediaSourceEditor-table .cell, .Cellraspred-table button {
	word-break: break-word!important;
}
.MediaSourceEditor .el-table tr:hover {
    background: rgb(1, 176, 224, 0.33);
}

</style>
